import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { LoginService } from './../../../login/login.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SYSCONF_LIMIT, SYSCONF_SIGLA } from '../../../../app.api';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { EstoqueService } from '../../estoque.service';
import { PreCadastroService } from 'src/app/pre-cadastro/pre-cadastro.service';
import { PessoaService } from '../../../pessoa/pessoa.service';
import { Suprimento } from '../suprimento';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-suprimento-list',
	templateUrl: './suprimentoList.component.html',
	styleUrls: ['./suprimentoList.component.scss']
})

export class SuprimentoListComponent implements OnInit{
	@ViewChild('Swal') public swal: SwalComponent;
	@ViewChild('SwalDelete') public swalDelete:SwalComponent; 
	public suprimento: Suprimento[];
	suprimento_id:number = null;
	public message:string = '';
	edit:boolean = false;
	detail:boolean = false;
	delete:boolean = false;
	create:boolean = false;
	suprimentosTiposSelect = new Array();
	suprimentosCategoriasSelect = new Array();
	suprimentosMarcasSelect = new Array();
	params = null;
	page = 1;
	totalPages:number = 1;
	recordsPerPage:number = SYSCONF_LIMIT;
	buscaForm: FormGroup;
	formExportar: FormGroup;
	sigla = SYSCONF_SIGLA;
	constructor(private activatedRoute: ActivatedRoute, public loginService: LoginService, private modalService: NgbModal, private router: Router, private estoqueService: EstoqueService, private formBuilder: FormBuilder, private preCadastroService: PreCadastroService){
		this.preCadastroService.getOptions('estoque/suprimento/tipo')
        .subscribe( (success) => {
			this.suprimentosTiposSelect = success.dados;
		},
		(error) => {
			// this.swal.text = error.error.message;
			// this.swal.type = "error";
			// this.swal.title = "Erro!";
			// this.swal.show();
		});

		this.preCadastroService.getOptions('estoque/suprimento/categoria')
        .subscribe( (success) => {
			this.suprimentosCategoriasSelect = success.dados;
		},
		(error) => {
			// this.swal.text = error.error.message;
			// this.swal.type = "error";
			// this.swal.title = "Erro!";
			// this.swal.show();
		});

		this.preCadastroService.getOptions('estoque/suprimento/marca')
        .subscribe( (success) => {
			this.suprimentosMarcasSelect = success.dados;
		},
		(error) => {
			// this.swal.text = error.error.message;
			// this.swal.type = "error";
			// this.swal.title = "Erro!";
			// this.swal.show();
		});

		this.buscaForm = this.formBuilder.group({
			nome: this.formBuilder.control(''),
			sku: this.formBuilder.control(''),
			suprimento_categoria_id: this.formBuilder.control(''),
			suprimento_tipo_id: this.formBuilder.control(''),
			suprimento_marca_id: this.formBuilder.control(''),

		});

	}
	changePage(event){
		let page = parseInt(event);
		let newParams:Object = new Object();
		this.activatedRoute.params.subscribe(
			param => {
				for(let i in param) {
					if(i != 'page') 
						newParams[i] = param[i];
				}
			})
		if(!page)
		return;
		this.router.navigate(['/'+SYSCONF_SIGLA+`/estoque/suprimento/page/${page}`,newParams]);
	}
	ngOnInit(){ 
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(t.permissao.estoque_suprimento.includes("CONSULTAR"))
			this.detail = true;
		if(t.permissao.estoque_suprimento.includes("CRIAR"))
			this.create = true;
		if(t.permissao.estoque_suprimento.includes("EDITAR"))
			this.edit = true;
		if(t.permissao.estoque_suprimento.includes("EXCLUIR"))
			this.delete = true;
		this.activatedRoute.params.subscribe(params => {
			this.paramsChange(params);
		});
	}

	initFormExportar(){
		this.formExportar = this.formBuilder.group({
			campos: new FormArray([]),
		});
	}
	openExportModal(modal) {
		this.initFormExportar();
		this.modalService.open(modal,{size: 'lg', backdrop: 'static' });
	}

	askDelete(id:number){
		this.suprimento_id = id;
		this.swalDelete.show();
	}

	confirmDelete(){
		this.estoqueService.del('suprimento',this.suprimento_id).subscribe( 
		(success) => {
			this.swal.text = "Suprimento deletado com sucesso!";
			this.swal.type = "success";
			this.swal.title = "Pronto!";
			this.swal.show();
		},
		(error) => {
			this.swal.text = error.error.message;
			this.swal.type = "error";
			this.swal.title = "Erro!";
			this.swal.show();
		});
	}

	paramsChange(params) {
		this.message = "";
		this.params = params;
		this.estoqueService.list('suprimento',params)
		.subscribe(
			(suprimento) => {
				this.suprimento = suprimento.dados;
				this.suprimento.forEach( (v,k) => {
					this.suprimento[k].total = 0;
					v.estoque.forEach( (v2,k2) => {
						this.suprimento[k].total = parseInt(v2.quantidade);
						
					})
				})
				this.totalPages = suprimento.paging.rows;
				this.page = params['page'];
			},
			(error) => {
				this.message = error.error.message;
			})
	}

	onSubmit(){
		this.router.navigate(['/'+SYSCONF_SIGLA+'/estoque/suprimento/page/1',this.buscaForm.value]);
	}
	
	onCloseModal(){
		let params = new Array();
		params['page'] = 1;
		if(this.swal.type == "success"){
			this.estoqueService.list('suprimento',params)
			.subscribe(
				(suprimento) => {
					this.suprimento = suprimento.dados;
					this.totalPages = suprimento.paging.rows;
					this.page = params['page'];
				},
				(error) => {
					this.message = error.error.message;
				})
		}
	}
}
